import { DropDownList } from "@progress/kendo-react-dropdowns"
import { states } from "../../data/state"
import { USState } from "../../models/USState"
import { useState } from "react"

export interface StateSelectorProps {
    state: string,
    stateChange: Function,
    children?: React.ReactNode
}

export const StateSelector = (props: StateSelectorProps) => {
    let currentState = states.find(x => x.abbreviation === props.state);
    const [state, setState] = useState(currentState ? currentState : {} as USState);

    const stateChange = (e: any) => {
        setState(e.value);
        props.stateChange(e);
    }

    return <DropDownList name={'State'} dataItemKey={"abbreviation"} textField={"name"} data={states} value={state} required={true} onChange={(e) => stateChange(e)} />
}